export var EEffectiveUxModes;
(function (EEffectiveUxModes) {
    EEffectiveUxModes["IFRAME"] = "iframe";
    EEffectiveUxModes["WINDOW"] = "window";
    EEffectiveUxModes["REDIRECT"] = "redirect";
    EEffectiveUxModes["SDK"] = "sdk";
})(EEffectiveUxModes || (EEffectiveUxModes = {}));
export var EErrorTypes;
(function (EErrorTypes) {
    EErrorTypes["TECHNICAL_ERROR"] = "TECHNICAL_ERROR";
    EErrorTypes["ACCESS_ERROR"] = "ACCESS_ERROR";
    EErrorTypes["RESOURCE_ERROR"] = "RESOURCE_ERROR";
    EErrorTypes["INPUT_ERROR"] = "INPUT_ERROR";
})(EErrorTypes || (EErrorTypes = {}));
